import './bootstrap';
import './styles';
import './magic-for-e2e-tests';
import { renderApp } from './create-onboarding-wizard';

const removeLoader = () => {
  window.document.querySelector('#wheely-progress')?.remove();
};

removeLoader();
renderApp();
